module.exports = __webpack_public_path__ + "static/media/5.d5d2a05e.jpg";